module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAaVBMVEUAAAD////////////////FCzbODzvLDjnIDTfREDzBCjPUEj6+CTPWE0C9CDLrsL7TMlf++vv9+vrxsL7iZYLXYXzdNVvGLE/MGkLytMLws8Horbrof5fnfpfdepHcepDLLFHZIEq/FDztusXiAAAABHRSTlMA+sY3Lt1FWwAAALxJREFUSMft1UcOwjAURdEU0xKCu53e9r9IEIqA5Evf9giEcsfvzFyiPa/SJCaexUn62IM5StIoIUElEQnsXwGXykyTUZL7gcoUS6byAW3+rmjdoMtXdS5QXzbVOOBsCxhHgTyCJAoUBAoF7ARiKCghKHFwBuGAQcBQoA8gjQIKAUWBGJ+jLHvtR4ECQrNN1HX4+vW+dx/v4frR4HOBqL0tWep3RUWj7Txb3YifeTW+DIKf++APJfjL2vPpDtz2I99q66sLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flag/ja@2x.png
// module id = 3qzn
// module chunks = 0